import React from 'react'
import NumberFormat from 'react-number-format'

export function TextMaskCC(props) {
  const { inputRef, ...other } = props

  return <NumberFormat {...other} getInputRef={inputRef} format="#### #### #### #### ####" />
}

export function TextMaskCVV(props) {
  const { inputRef, ...other } = props

  return <NumberFormat {...other} getInputRef={inputRef} format="#####" allowNegative={false} />
}

export function TextMaskExpiration(props) {
  const { inputRef, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      format="##/##"
      allowNegative={false}
      allowLeadingZeros={true}
      placeholder="MM/YY"
    />
  )
}

export function TextMaskDollaBills(props) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      prefix="$"
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      onValueChange={values => onChange(values.value)}
    />
  )
}

export function TextMaskPhone(props) {
  const { inputRef, ...other } = props

  return <NumberFormat {...other} getInputRef={inputRef} format="(###) ###-####" mask=" " />
}
